import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useEffect, useState } from "react";
import { Marker, TileLayer } from "react-leaflet";
import { useMapEvents } from "react-leaflet/hooks";

export default function MapRoutes(props) {
  const [markerLatLng, setMarkerLatLng] = useState([]);

  const map = useMapEvents({});

  useEffect(() => {
    if (props.locations) {
      setMarkerLatLng(props.locations);
    }
  }, [props.locations]);

  useEffect(() => {
    if (props.changeZoom) {
      map.setZoom(11);
      props.setChangeZoom(false);
    }
  }, [props.changeZoom]);

  L.DomUtil.addClass(map._container, "crosshair-cursor-enabled");

  const tileLayerUrl = window.ENV.tileLayerUrl
    ? window.ENV.tileLayerUrl
    : "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

  return (
    <>
      <TileLayer
        attribution="&copy; OpenStreetMap contributors"
        url={tileLayerUrl}
      ></TileLayer>
      {markerLatLng &&
        markerLatLng.map((m) => {
          const markerHtmlStyles = `
                background-color: ${m.color};
                width: 1.5rem;
                height: 1.5rem;
                display: block;
                // left: -1.5rem;
                // top: -1.5rem;
                // position: relative;
                border-radius: 3rem 3rem 0;
                transform: rotate(45deg);
                border: 1px solid #FFFFFF`;

          return (
            <Marker
              eventHandlers={{
                click: (event) => {
                  props.setZoneIndex(m.zoneIndex);
                  if (props.isSearch) {
                    props.setLocationRout({
                      ...props.locationRout,
                      id: m.logesticID,
                    });
                    props.setOrderModel({
                      ...props.orderModel,
                      logesticID: m.logesticID,
                    });
                    return;
                  }
                  props.setLocationRout({
                    ...props.locationRout,
                    id: m.id,
                  });
                  props.setOrderModel({
                    ...props.orderModel,
                    logesticID: m.id,
                  });
                },
                // contextmenu: (event) => {
                //   props.setOrderModel({
                //     ...props.orderModel,
                //     logesticID: m.id,
                //   });
                //   // popup.openOn();
                // },
              }}
              key={m.id}
              position={[m.latitude, m.longitude]}
              icon={L.divIcon({
                className: "my-custom-pin",
                html: `<span style="${markerHtmlStyles}" />`,
              })}
            ></Marker>
          );
        })}
    </>
  );
}
